import { Component, OnInit, Output,EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from 'src/app/services/Modules/company.service';
import * as usa_states from 'src/app/shared/popup-dialogs/facility-add-dialog/usa_states';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FacilityService } from 'src/app/services/facility.service';
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { FacilityContactDialogComponent } from "src/app/shared/popup-dialogs/facility-contact-dialog/facility-contact-dialog.component";
import { AuthService } from '../../../../../services/auth.service';
import { lastValueFrom } from 'rxjs';
import { PCCService } from 'src/app/services/pcc.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
    selector: 'app-company-facility-form',
    templateUrl: './company-facility-form.component.html',
    styleUrls: ['./company-facility-form.component.css']
})
export class CompanyFacilityFormComponent implements OnInit {
    @Output() newFacilityOutput=new EventEmitter();
    usa_states = usa_states.default.slice(1)
    loaderId = 'company-user-management-form-loader';
    facility_id: string;
    allPos: any;
    timezones : any = []
    pods = [
        "E. WA",
        "S. WA",
        "N. WA",
        "Utah",
        "W. TX",
        "ID/AZ",
        "Oregon"
    ];
    model = {
        title: '',
        address: '',
        street: '',
        city: '',
        state: '',
        zip_code: '',
        trueRCMID: '',
        pod: '',
        company_id: null,
        source: null,
        external_id: null,
        organization_id: null,
        pcc_orgUuid: null,
        npi: null,
        cardiology_name: '',
        pulmonary_name: '',
        // contact: {
        //     first_name: '',
        //     last_name: '',
        //     phone: '',
        //     email: '',
        //     position: ''
        // }
        place_of_service: '',
        initial_load: false,
        initial_load_progress: 'not_started',
        pos_id: null,
        timeZone : '',
        pcc_app_name: null,
        pcc_facId: null,
        pcc_timeZone: null
    }
    public dataSource: any;
    displayedColumns: string[] = ['name', 'position', 'email', 'phone', 'operations', 'association'];
    isRedirectedFromParentRoute: boolean = false;
    isProductOwner: boolean = false;
    currentUser: any;
    isPccFacililty: boolean = false;
    showFetchPCCFacilityFields: boolean = false;
    pccAppNames: {
        label: string;
        value: string;
      }[] = [];
    fetching_pcc_facility_details_inprogress: boolean|null = null;
    initial_load_inprogress = false
    isInitialLoadBtnDisable:boolean=false
    constructor(private _location: Location,
        private route: ActivatedRoute,
        private loader: NgxUiLoaderService,
        private companyService: CompanyService,
        private facilityService: FacilityService,
        private dialog: MatDialog,
        private _router: Router,
        private _authService: AuthService,
        private toastr: ToastrService,
        private pccService: PCCService,
        private commonService: CommonService) {
        this.model.company_id = this.route.parent.parent.snapshot.params.id;
        this.facility_id = this.route.snapshot.params.id;
        this.currentUser = this._authService.currentUser;
        this.route.queryParams.subscribe((params: any) => {
            if (params) {
                this.isRedirectedFromParentRoute = params.isRedirectedFromParentRoute;
            }
        });
    }

    ngOnInit(): void {
        this.timezones = this.commonService.getFormattedTimeZones();  
        if (this.facility_id) {

            this.loader.startLoader(this.loaderId);

            this.facilityService.getFacility(this.facility_id).subscribe((response: any) => {
                if (response.status === 200) {
                    // if(response.data.contact === undefined) {
                    //     response.data.contact = {
                    //         first_name: '',
                    //         last_name: '',
                    //         phone: '',
                    //         email: '',
                    //         position: ''
                    //     }
                    // }
                    if (response.data.trueRCMID === undefined) {
                        response.data.trueRCMID = "";
                    }

                    if(response.data&&(response.data.source?.includes('PointClickCare')||(response.data.pcc_facId))){
                        this.isPccFacililty=true;
                    }
                    this.model = response.data;
                    console.log(response.data);
                }
                this.loader.stopLoader(this.loaderId);
            });
            this.companyService.getFacilityContacts({ facility: this.facility_id }, 'all')
                .subscribe(res => {
                    console.log(res.data.array);
                    this.dataSource = new MatTableDataSource(res.data.array);
                });

        }
        if (this.currentUser.product_owner == true) {
            this.isProductOwner = true;
        }
        this.companyService.getAllPOS().subscribe((res: any) => {
            if (res.status == 200) {
                this.allPos = res.data;
            } else {
                this.allPos = []
                console.log('something went wrong');
            }
        });
        this.initPCCAppNames();
    }

    initPCCAppNames() {
        this.pccService.getPCCAppNames().subscribe((res: any) => {
          if(res.status === 200) {
            this.pccAppNames = res.data;
          }
        })
      }

    goBack() {
        if (this.isRedirectedFromParentRoute) {
            const companyId = this.route.parent.parent.snapshot.params.id;
            return this._router.navigate([`/company/${companyId}/facilities/list`]);
        }
        this._location.back();
    }
    matrixPatientExtract(){
        this.isInitialLoadBtnDisable = true
        this.toastr.info('Initial Patient Load is in progress...')
        this.initial_load_inprogress = true;
        let result =  this.companyService.matrixPatientExtract(this.facility_id, this.model.external_id).subscribe((response: any)=>{
            if(response){
                this.isInitialLoadBtnDisable = false
            }
        })
    }

    async handleSubmit(e) {
        
        if (this.model.title
            //  && this.model.contact.first_name 
            //  && this.model.contact.last_name 
            //  && this.model.contact.email 
            //  && this.model.contact.phone 
            //  && this.model.contact.position
        ) {

            try {
                this.loader.startLoader(this.loaderId);
                if (this.facility_id) {
                    let response = await lastValueFrom(this.companyService.updateFacility(this.model)) as any;
                        this.loader.stopLoader(this.loaderId);
                        this.toastr.success('Facility updated succesfully', 'Success')
                        // this.goBack();
                    // })
                } else {
                    let data = await  lastValueFrom(this.companyService.addFacility(this.model) ) as any
                        // (data) => {
                        this.newFacilityOutput.emit(data);
                        this.toastr.success('Facility added successfully', 'Success');
                            // this.goBack();
                        // }
                        // );
                        if(this.model.source == 'MatrixCare' && this.model.external_id){
                            this.matrixPatientExtract()
                        }
                    }
                this.goBack();
            } catch (error) {
                this.loader.stopLoader(this.loaderId);
                this.toastr.error('Something went wrong', 'Error');
            }
        }
    }

    editFacilityContact(contact) {
        const dialogRef = this.dialog.open(FacilityContactDialogComponent, {
            width: '600px',
            data: { update: true, contact: contact }
        });

        dialogRef.afterClosed().subscribe(async (data) => {
            // @ts-ignore
            if (contact._id === this.model.contact._id) {
                this.loader.startLoader(this.loaderId);

                this.facilityService.getFacility(this.facility_id).subscribe((response: any) => {
                    if (response.status === 200) {
                        this.model = response.data;
                    }
                    this.loader.stopLoader(this.loaderId);
                });
            }
            this.companyService.getFacilityContacts({ facility: this.facility_id }, 'all')
                .subscribe(res => {
                    this.dataSource = new MatTableDataSource(res.data.array);
                });
        });
    }

    deleteFacilityContact(contact) {
        let params = {
            _id: contact._id,
            is_active: false
        };
        this.companyService.updateFacilityContact(params)
            .subscribe(res => {
                this.toastr.success('Facility Contact Deleted', 'Success');
                this.companyService.getFacilityContacts({ facility: this.facility_id }, 'all')
                    .subscribe(res => {
                        this.dataSource = new MatTableDataSource(res.data.array);
                    });
            });
    }

    openDialog() {
        if (!this.facility_id) {
            this.toastr.error('Please add facility first', 'Error');
            return;
        }
        const dialogRef = this.dialog.open(FacilityContactDialogComponent, {
            width: '600px',
            data: { facility_id: this.facility_id }
        });

        dialogRef.afterClosed().subscribe(async (data) => {
            this.companyService.getFacilityContacts({ facility: this.facility_id }, 'all')
                .subscribe(res => {
                    this.dataSource = new MatTableDataSource(res.data.array);
                });
        });
    }

    numberToString(number) {
        return String(number);
    }
    keyPressNumbers(event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        // Only Numbers 0-9
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        }
        else {
            return true;
        }
    }
    keyPressAlphanumeric(event) {

        var inp = String.fromCharCode(event.keyCode);

        if (/[a-zA-Z0-9\s/-_-,-.-(-)-]/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }
    allowOnlyText(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode == 32) {
            return true;    
        }
        if (charCode > 90 && charCode < 97) {
            return false;
        }

        if (charCode < 65 || charCode > 122) {
            return false;
        }
        return true;
    }
    toggle(contact, $event) {
        let params = {
            _id: contact._id,
            is_associated: $event.checked,
        };
        this.companyService.updateFacilityContact(params)
            .subscribe(res => {
                this.toastr.success('Facility Contact Association Updated', 'Success');
                this.companyService.getFacilityContacts({ facility: this.facility_id }, 'all')
                    .subscribe(res => {
                        this.dataSource = new MatTableDataSource(res.data.array);
                    });
            });
    }

    async fetchPCCFacility(pcc_facId, pcc_orgUuid, pcc_app_name) {
        this.loader.startLoader(this.loaderId);
        try {
            const pccFacilityResponse = await lastValueFrom(this.pccService.getFacility(pcc_facId, pcc_orgUuid, pcc_app_name)) as any;
            if(pccFacilityResponse.status === 200) {
                this.initializePCCFacilityValues(pccFacilityResponse.data)
            }
        } catch (error) {
            console.log(error)
            this.toastr.error('Something went wrong while fetching pcc facility details' , 'Error');
            
        }
        this.loader.stopLoader(this.loaderId);

    }

    initializePCCFacilityValues(pccFacility) {
        const stateIndex = usa_states.default
            .findIndex((state) => state.abbreviation === pccFacility.state)
            .toString();

        this.model.title = pccFacility.facilityName;
        this.model.address = `${pccFacility.addressLine1} ${pccFacility.city} ${pccFacility.country}`;
        this.model.city = pccFacility.city;
        this.model.state = stateIndex;
        this.model.zip_code = pccFacility.postalCode;
        this.model.pcc_facId = pccFacility.facId;
        this.model.timeZone = pccFacility.timeZone;
        this.model.pcc_timeZone = pccFacility.timeZone;
        this.model.pcc_orgUuid = pccFacility.orgUuid;
        this.model.source = 'PointClickCare';

    }
}
